import React from 'react';
import { isFreeeLoggedIn } from '../utils/AuthService'
import { Redirect } from 'react-router-dom'


const FREEE_ENDPOINT = process.env.REACT_APP_FREEE_ENDPOINT
const CLIENT_ID = process.env.REACT_APP_FREEE_CLIENT_ID
const REDIRECT_URI = process.env.REACT_APP_FREEE_REDIRECT_URI

class Login extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let authorizeUrl = FREEE_ENDPOINT + "?"
    authorizeUrl += "client_id=" + CLIENT_ID + "&"
    authorizeUrl += "response_type=code&"
    authorizeUrl += `redirect_uri=${REDIRECT_URI}`
    return (
      <div>
        <div className="header">
          <h2>G Suite連携アプリ</h2>
        </div>
        <div className="vb-container">
          <a href={authorizeUrl} className="vb-jumpButton">freeeアカウントへログイン</a>
          <br />
          <br />
          ※ご利用にはfreeeアカウントとGSuiteアカウントへのログインが必要です
          </div>
      </div>
    )
  }
}
export default Login;